import {
  ITopLevelProps,
  ViewModes,
} from "../support/registration_form_component.tsx";
import { WelcomeStep } from "../form/welcome_step.tsx";
import { RegistrationGeneralInfo } from "../form/general_info.tsx";
import { RegistrationContactInfo } from "../form/contact_info.tsx";
import {
  CarveOutPayer,
  Pbm,
  RegistrationClaims,
  TopLevelCommentsField,
  Tpa,
} from "../form/claims.tsx";
import { RegistrationReviewSubmit } from "../form/review_submit.tsx";
import { RegistrationThankYou } from "../form/thank_you.tsx";

export function CoveredCA(props: ITopLevelProps) {
  const { context, welcomeStepProps } = props;

  const { config, current_step, view_mode } = context;

  const downloadableView = view_mode === ViewModes.DOWNLOADABLE;

  return (
    <div>
      <WelcomeStep
        {...context}
        {...welcomeStepProps}
        active={downloadableView || current_step === 0}
      />

      <RegistrationGeneralInfo
        {...context}
        active={downloadableView || current_step === 1}
        dental={false}
        showEstimates={false}
      />

      <RegistrationContactInfo
        {...context}
        active={downloadableView || current_step === 2}
        contactTypes={config.contactTypes}
      />

      <RegistrationClaims
        {...context}
        active={downloadableView || current_step === 3}
      >
        <Tpa {...context} />
        <Pbm {...context} />
        <CarveOutPayer {...context} />
        <TopLevelCommentsField
          form={context.form}
          setFormValue={context.setFormValue}
        />
      </RegistrationClaims>

      <RegistrationReviewSubmit
        {...context}
        active={downloadableView || current_step === 4}
      />

      <RegistrationThankYou
        {...context}
        active={downloadableView || current_step === 5}
      />
    </div>
  );
}
